<template>
  <div>
    <p>
      <strong>{{ $t('contract.employment_details.location.label') }}</strong>
      <span class="user-output">{{ details.location }}</span>
    </p>

    <hr />

    <p>
      <strong>{{ $t('contract.employment_details.starting_date.label') }}</strong>
      <span class="user-output">
        {{
        startingDate }}
      </span>
    </p>

    <hr />

    <p>
      <strong>{{ $t('contract.employment_details.headline') }}</strong>
    </p>
    <div>
      <span
        v-show="details.indefinite"
      >{{ $t('contract.employment_details.time.indefinite.label') }}</span>
      <span
        v-show="details.temporary"
      >{{ $t('contract.employment_details.time.temporary.label', {'endingDate': endingDate}) }}</span>
    </div>

    <br />

    <p>
      <strong>{{ $t('contract.employment_details.info_paragraph_title') }}</strong>
      <br />
      {{ $t('contract.employment_details.info_paragraph') }}
    </p>

    <hr />
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  computed: {
    details() {
      return this.$store.state.contract.employmentDetails;
    },
    startingDate() {
      if (this.details.startingDate) {
        let date = new Date(this.details.startingDate);
        return format(date, "dd/MM/yyyy");
      } else {
        return "";
      }
    },
    endingDate() {
      if (this.details.endingDate) {
        let date = new Date(this.details.endingDate);
        return format(date, "dd/MM/yyyy");
      } else {
        return "";
      }
    }
  }
};
</script>
